import { render, staticRenderFns } from "./timer.vue?vue&type=template&id=4e56a1b6&scoped=true&"
import script from "./timer.ts?vue&type=script&lang=ts&"
export * from "./timer.ts?vue&type=script&lang=ts&"
import style0 from "./timer.vue?vue&type=style&index=0&id=4e56a1b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e56a1b6",
  null
  
)

export default component.exports